import React, { Component } from 'react';

export class ItemStockInfo extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        var locationQtyInfo = this.props.locationQtyInfo;
        var locationQtyInfoArray = [];
        for (var location in locationQtyInfo) {
            var locationInfo = locationQtyInfo[location];
            if (locationInfo.qtyOnHand > 0 || locationInfo.qtyInTransit > 0) {
                locationQtyInfoArray.push(locationInfo);
            }
        }
        return (
            <div className='ItemStockInfo'>
                <p><b className='itemQty'> {this.props.qtyToCancel}</b> {this.props.itemName}. Are you sure?</p>
                <p>Product Lifecycle Stage: <b>{this.props.lifecycleStage}</b></p>
                <table className='itemStockInfoTable'>
                    <th>Location</th>
                    <th>Qty On Hand</th>
                    <th>Qty In Transit</th>
                {
                    locationQtyInfoArray.map(function (qtyInfo, idx) {
                        return (
                            <tr>
                                <td>{qtyInfo.locationName}</td>
                                <td>{qtyInfo.qtyOnHand}</td>
                                <td>{qtyInfo.qtyInTransit}</td>
                            </tr>
                        )
                    })
                }
              </table>
            </div>
        );
    }
}
